import { render } from "./FieldBaseComponent.vue?vue&type=template&id=6a0b4efc"
import script from "./FieldBaseComponent.vue?vue&type=script&lang=js"
export * from "./FieldBaseComponent.vue?vue&type=script&lang=js"

import "./FieldBaseComponent.vue?vue&type=style&index=0&id=6a0b4efc&lang=css"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
